<template>
    <div class="pagination-wrapper d-flex justify-content-center justify-content-sm-end align-items-center gap-1">
        <div v-if="loading" class="spinner-border spinner-border-sm text-dark mr-1" role="status" style="border-width: 2px">
            <span class="sr-only">Loading...</span>
        </div>

        <button type="button" class="btn btn-clear btn-medium" @click="loadPrevPage" :disabled="(page-1) <= 0">
            <i class="las la-angle-left fs-3 fw-600"></i>
        </button>

        <div class="fw-600 fs-5 text-nowrap">
            {{page}} <span class="text-muted" style="opacity: 0.6">/</span> <span class="text-muted" style="opacity: 0.6">{{lastPage}}</span>
        </div>

        <button type="button" class="btn btn-clear btn-medium" @click="loadNextPage" :disabled="(page+1) > lastPage">
            <i class="las la-angle-right fs-3 fw-600"></i>
        </button>
    </div>
</template>

<style lang="scss" scoped>
    .pagination-wrapper {
        container: paginator / inline-size;
    }

    @container paginator (width < 400px) {
        .fs-3 {
            font-size: 23px !important;
        }

        .fs-5 {
            font-size: 16px !important;
        }
    }
</style>

<script>
export default {
    props: ['page', 'lastPage', 'loading'],
    methods: {
        loadPrevPage() {
            this.$emit('loadPrevPage');
        },
        loadNextPage() {
            this.$emit('loadNextPage');
        },
    }
}
</script>
